// extracted by mini-css-extract-plugin
export default {"main-grid":"oyWMVx4sGtJlV4oWQ3af"};